const Functions = {
  changeQuantity(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: quantity, line: line }),
    })
      .then((response) => response.json())
      .then((data) => {
        window.dispatchEvent(new CustomEvent("update-cart", { detail: data }));
      })
      .catch((errror) => console.error("Error:", error));
  },
  addToCart(form) {
    let formData = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        window.dispatchEvent(new CustomEvent("update-cart"));
        window.dispatchEvent(new CustomEvent("toggle-cart"));
        document.body.classList.add("overflow-hidden");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
};

window.Functions = Functions;

const videos = document.querySelectorAll(".grid-video");
const videosWrapp = document.querySelectorAll(".grid-section__video-wrapper");
const buttonsMobile = document.querySelectorAll(".grid-section__mobile-button");

buttonsMobile.forEach((element, index) => {
  element.addEventListener("click", function (e) {
    if (videos[index].paused) {
      videos[index].play();
      videosWrapp[index].classList.add("active");
    } else {
      videos[index].pause();
      videosWrapp[index].classList.remove("active");
    }
  });
});

videosWrapp.forEach((element, index) => {
  element.addEventListener("click", function (e) {
    if (videos[index].paused) {
      videos[index].play();
      element.classList.add("active");
    } else {
      videos[index].pause();
      element.classList.remove("active");
    }
  });
});
